(() => {
    const header = document.getElementById('header');
    const startScroll = window.scrollY;
    console.log(startScroll);

    if (startScroll > 1) {
        header.classList.add('navbar--sticky');
    }

    window.addEventListener('scroll', function() {
        if (window.scrollY >= 1) {
            header.classList.add('navbar--sticky');
        } else {
            header.classList.remove('navbar--sticky');
        }
    });
})();
